
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.22 17.859c-.18.18-.5.21-.71 0a.504.504 0 010-.71l3.39-3.392-1.41-1.41-3.39 3.39c-.19.201-.51.191-.71 0a.504.504 0 010-.71l3.39-3.391-1.41-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.514.514 0 010-.71l3.39-3.391-1.42-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.514.514 0 010-.71l4.38-4.382 1.87 1.861c.95.95 2.59.94 3.54 0a2.5 2.5 0 000-3.542l-1.86-1.86.28-.28c.78-.781 2.05-.781 2.83 0l4.24 4.241c.78.78.78 2.051 0 2.832l-8.2 8.204zm9.61-6.784a4.011 4.011 0 000-5.662L17.59 1.17a4.006 4.006 0 00-5.66 0l-.28.28-.28-.28a4.006 4.006 0 00-5.66 0L2.17 4.712a3.996 3.996 0 00-.4 5.193l1.45-1.45c-.39-.751-.26-1.702.37-2.332l3.54-3.542c.78-.78 2.05-.78 2.83 0l3.56 3.562c.18.18.21.5 0 .71-.21.21-.53.18-.71 0L9.52 3.572l-5.8 5.793a2.5 2.5 0 000 3.541c.39.39.89.63 1.42.7a2.46 2.46 0 002.12 2.122 2.46 2.46 0 002.12 2.12c.07.541.31 1.031.7 1.422.47.47 1.1.73 1.77.73.67 0 1.3-.26 1.77-.73l8.21-8.194z","fill":"currentColor"}})])
          )
        }
      }
    